import { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import MoodForm from './components/MoodForm';
import SubstancesForm from './components/SubstancesForm';
import SexForm from './components/SexForm';
import CustomMetricForm from './components/CustomMetricForm';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';

// Get the API URL from environment variables, default to empty string (same domain)
const API_URL = process.env.REACT_APP_API_URL || '';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user is authenticated on app load
  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        // Check if there's a stored auth state
        const storedAuth = localStorage.getItem('isAuthenticated');
        
        if (storedAuth === 'true') {
          // Verify with backend that session is still valid
          const response = await fetch(`${API_URL}/auth/verify`, {
            method: 'GET',
            credentials: 'include',
          });
          
          if (response.ok) {
            setIsAuthenticated(true);
          } else {
            // If backend verification fails, clear local storage
            localStorage.removeItem('isAuthenticated');
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth verification error:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  const handleLogin = (value) => {
    setIsAuthenticated(value);
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
      
      // Always clear local authentication state, even if the server request fails
      localStorage.removeItem('isAuthenticated');
      setIsAuthenticated(false);
      
      if (!response.ok) {
        console.warn('Logout request failed, but local state was cleared');
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Still clear local state on error
      localStorage.removeItem('isAuthenticated');
      setIsAuthenticated(false);
    }
  };

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route 
          path="/login" 
          element={
            isAuthenticated ? 
              <Navigate to="/" replace /> : 
              <Login onLogin={handleLogin} />
          } 
        />
        <Route 
          path="/" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div>
                <button 
                  className="logout-button" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
                <LandingPage />
              </div>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/mood-form" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div>
                <button 
                  className="logout-button" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
                <div className="nav-links">
                  <Link to="/">Home</Link>
                </div>
                <MoodForm />
              </div>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/substances-form" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div>
                <button 
                  className="logout-button" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
                <div className="nav-links">
                  <Link to="/">Home</Link>
                </div>
                <SubstancesForm />
              </div>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/sex-form" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div>
                <button 
                  className="logout-button" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
                <div className="nav-links">
                  <Link to="/">Home</Link>
                </div>
                <SexForm />
              </div>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/custom-metric-form" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div>
                <button 
                  className="logout-button" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
                <div className="nav-links">
                  <Link to="/">Home</Link>
                </div>
                <CustomMetricForm />
              </div>
            </ProtectedRoute>
          } 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
